export default {
    read(response) {
        return response.filter(rate => {
            return rate.ccy === 'EUR' || rate.ccy === 'USD';
        });
    },
};
